<mat-card class="m-auto padding12 home-card boxshadowgrey">
    <div>
        <button mat-icon-button color="primary" class="back-button" routerLink="/menu">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </div>
    <div class="content">
    <mat-card-title-group class="home-card" id="title">
        <mat-card-title>{{ "BUS.HEADER" | translate}}</mat-card-title>
    </mat-card-title-group>

    <mat-card-content>
        <div class="home-card" id="content">
            <ng-container *ngIf="this.gatewayConnectionService.gatewayConnected == false"
                    >{{ "MESSAGES.CONN_WAITING" | translate}}</ng-container>

            <ng-container *ngIf="this.gatewayConnectionService.gatewayConnected == true">    
            <ng-container *ngIf="this.filled == false">
                <div class="loading">
                    <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
                </div>
            </ng-container>
            <ng-container *ngIf="this.loaded == false && this.noConnection == true">
                <div class="noConnection">
                    <a>{{ this.errorMessage }}</a></div>
            </ng-container>
            <ng-container *ngIf="this.loaded == true && this.filled == true">
                <div class="home">
                    <div *ngFor="let num of this.count" class="home-part">
                        <div class="part">
                            <div class="busPart">
                                <a class="busTag">CAN {{ num }}</a>
                                <svg width="100%" height="100%" class="versuch" id="line {{num}}" xmlns="http://www.w3.org/2000/svg">
                                    <polyline points="0,30 930,30 930,20 930,40" style="fill:none;stroke:var(--accent-lighter-color);stroke-width:5"/>
                                </svg>
                            </div>
                            <div class="singlePart">
                                <ng-container *ngFor="let item of refData">
                                    <ng-container *ngFor="let id of item.busNumber">
                                        <ng-container *ngIf="num == id">
                                            <div class="element" id="element {{item.name}}">
                                                <button class="icon" (click)="this.openDialog(item)" [ngClass]="{
                                                    'neutral': item.state[item.busNumber.indexOf(num)] == 0,
                                                    'good': item.state[item.busNumber.indexOf(num)] == 1,
                                                    'ok': item.state[item.busNumber.indexOf(num)] == 2,
                                                    'bad': item.state[item.busNumber.indexOf(num)] == 3
                                                }"
                                                #tooltip="matTooltip"
                                                [matTooltip]="'ID: ' + item.canIds[item.busNumber.indexOf(num)] + ', State: ' + (this.stateList[item.state[item.busNumber.indexOf(num)]] | translate)"
                                                matTooltipPosition="below"
                                                >
                                                    <mat-icon class="icon-img">settings</mat-icon>
                                                    <a>{{item.name}}</a>
                                                    </button>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <svg id="svg1" width="0" height="0">
                        <path id="newPath" d="M0 0" stroke-width="0.3em" style="stroke:#555; fill:none;"/>
                    </svg>
                </div>
            </ng-container>
            </ng-container>
        </div>
    </mat-card-content>
</div>
</mat-card>